import { NavigationLink } from '@/types/interfaces';

export const portalRoutes: NavigationLink[] = [
  {
    name: 'Home',
    label: 'Home',
    route: { name: 'EligibilityRating' },
  },
  {
    name: 'Scores',
    label: 'Scores',
    childRoutes: [
      {
        name: 'CreditScoresEligibilityRating',
        label: 'MSE Credit Eligibility Rating',
        route: { name: 'CreditScoresEligibilityRating' },
      },
      {
        name: 'CreditScoresAffordabilityScore',
        label: 'MSE Affordability Score',
        route: { name: 'CreditScoresAffordabilityScore' },
      },
      {
        name: 'CreditScoresCreditScore',
        label: 'TransUnion Credit Score',
        route: { name: 'CreditScoresCreditScore' },
      },
    ],
  },
  {
    name: 'CreditReportSummary',
    label: 'Credit report',
    route: { name: 'CreditReportSummary' },
  },
  // {
  //   name: 'CreditScore',
  //   label: 'Credit score',
  //   route: { name: 'CreditScore' },
  // },
  // {
  //   name: 'AffordabilityScore',
  //   label: 'Affordability',
  //   route: { name: 'AffordabilityScore' },
  // },
  {
    name: 'CreditCardEligibility',
    label: 'Credit Cards Eligibility ',
    route: { name: 'EligibilityCreditCardsSearch' },
    additionalRoute: { name: 'EligibilityCreditCardsResults' },
  },
  {
    name: 'LoansEligibilitySetup',
    label: 'Loans Eligibility',
    route: { name: 'EligibilityLoansSearchPage' },
    additionalRoute: { name: 'LoansEligibilityCalculator' },
  },
  {
    name: 'GuidesAndHelp',
    label: 'Guides & help',
    childRoutes: [
      {
        name: 'DebtHelp',
        label: 'Get help with debt',
        route: 'https://tunirexun.com/loans/debt-help-plan/',
        external: true,
      },
      {
        name: 'RemortgagingHelp',
        label: 'Remortgaging help',
        route: 'https://tunirexun.com/mortgages/getting-ready-remortgage/',
        external: true,
      },
      {
        name: 'PaydayLoanHelp',
        label: 'Payday loan help',
        route: 'https://tunirexun.com/loans/payday-loans/',
        external: true,
      },
      {
        name: 'FAQ',
        label: 'FAQs & feedback',
        route: 'https://help.moneysavingexpert.com/en/',
        external: true,
      },
    ],
  },
];

export const portalRoutesAlternate: NavigationLink[] = [
  {
    name: 'Home',
    label: 'Home',
    route: { name: 'EligibilityRating' },
  },
  {
    name: 'Scores',
    label: 'Your Scores',
    childRoutes: [
      {
        name: 'CreditScoresEligibilityRating',
        label: 'MSE Credit Eligibility Rating',
        route: { name: 'CreditScoresEligibilityRating' },
      },
      {
        name: 'CreditScoresAffordabilityScore',
        label: 'MSE Affordability Score',
        route: { name: 'CreditScoresAffordabilityScore' },
      },
      {
        name: 'CreditScoresCreditScore',
        label: 'TransUnion Credit Score',
        route: { name: 'CreditScoresCreditScore' },
      },
    ],
  },
  {
    name: 'CreditReportSummary',
    label: 'Your TransUnion Credit Report',
    route: { name: 'CreditReportSummary' },
  },
  // {
  //   name: 'CreditScore',
  //   label: 'Your Credit Score',
  //   route: { name: 'CreditScore' },
  // },
  // {
  //   name: 'AffordabilityScore',
  //   label: 'Your Affordability Scores',
  //   route: { name: 'AffordabilityScore' },
  // },
  {
    name: 'CreditCardEligibility',
    label: 'Credit Cards Eligibility',
    route: { name: 'EligibilityCreditCardsSearch' },
    additionalRoute: { name: 'EligibilityCreditCardsResults' },
  },
  {
    name: 'LoansEligibilitySetup',
    label: 'Loans Eligibility',
    route: { name: 'EligibilityLoansSearchPage' },
    additionalRoute: { name: 'LoansEligibilityCalculator' },
  },
  {
    name: 'GuidesAndHelp',
    label: 'Guides & help',
    childRoutes: [
      {
        name: 'OtherCreditReports',
        label: 'Check other credit reports',
        route: { name: 'OtherCreditReports' },
      },
      {
        name: 'DebtHelp',
        label: 'Get help with debt',
        route: 'https://tunirexun.com/loans/debt-help-plan/',
        external: true,
      },
      {
        name: 'RemortgagingHelp',
        label: 'Remortgaging help',
        route: 'https://tunirexun.com/mortgages/getting-ready-remortgage/',
        external: true,
      },
      {
        name: 'PaydayLoanHelp',
        label: 'Payday loan help',
        route: 'https://tunirexun.com/loans/payday-loans/',
        external: true,
      },
      {
        name: 'FAQ',
        label: 'FAQs & feedback',
        route: 'https://help.moneysavingexpert.com/en/',
        external: true,
      },
    ],
  },
];
